import * as React from "react";
import { Box, Typography, CircularProgress, Paper, Button } from "@mui/material";
import { getCurrentSession } from "../../api/queries";

export default function AuthCallback(props: { handlePageChange: (page: string) => void }) {
  const { handlePageChange } = props;
  const [error, setError] = React.useState<string | null>(null);
  const [status, setStatus] = React.useState<"loading" | "ok">("loading");

  React.useEffect(() => {
  const run = async () => {
    try {
      // 🔒 0. Guard: only proceed if this is a real auth redirect
      const hasAuthParams =
        window.location.hash.includes("access_token") ||
        window.location.search.includes("type=");

      if (!hasAuthParams) {
        // Normal app start → AuthCallback should not be visible
        handlePageChange("Entry");
        return;
      }

      // 1. Finalize session from redirect
      const { data, error } = await getCurrentSession();
      if (error) throw error;
      if (!data.session) {
        throw new Error("No session found after authentication.");
      }

      const user = data.session.user;

      // 2. Ensure email is confirmed
      if (!user.email_confirmed_at) {
        throw new Error("Email not confirmed yet.");
      }

      // 3. Success → user must log in manually (Option A)
      setStatus("ok");
    } catch (e: any) {
      console.error("[AuthCallback]", e);
      setError(e?.message ?? "Authentication failed.");
    }
  };

  run();
}, [handlePageChange]);


  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "#F3F4F6" }}>
      <Paper sx={{ p: 4, borderRadius: 3, textAlign: "center", width: 420 }}>
        {error ? (
          <>
            <Typography fontWeight={900} color="error">
              Something went wrong
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => handlePageChange("Entry")}>
              Back to login
            </Button>
          </>
        ) : status === "loading" ? (
          <>
            <CircularProgress />
            <Typography sx={{ mt: 2, fontWeight: 900 }}>Finalizing…</Typography>
            <Typography variant="body2" sx={{ color: "#6B7280" }}>
              Preparing your account…
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={{ fontWeight: 900 }}>Email confirmed ✅</Typography>
            <Typography variant="body2" sx={{ color: "#6B7280", mt: 1 }}>
              Please log in to continue.
            </Typography>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => handlePageChange("Entry")}>
              Go to login
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
